module.exports = __webpack_public_path__ + "static/marketing-7994c8b1396154b8423cb2e8c3186b25.jpg";